export default {
  filter: '',
  loaded_init: false,
  products: []
}
